import React from 'react';
import Slider from './slider/Slider'

export default function MyRangeInput(props){
  return (
    <div>
      {props.label}
      <div className='slider'>
        <Slider min={0} max={10} step={1} value={props.value} onChange={(v) => {
            console.log(`new slider value ${v} old slider value ${props.value}`);
            props.onChange(v)
          }}
          loading={props.loading} tooltip={false} color={props.color} handleLabel={props.value}
          />
      </div>
    </div>
  )
}
